/**
 * @generated SignedSource<<06ad9edf638fdd78ec0c9d0f39ccb746>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type EmployeeProvider = "IPOOL" | "QUINYX" | "SOFTONE" | "TILTID" | "TOOEASY";
import { FragmentRefs } from "relay-runtime";
export type WidgetEmployeeScheduleIcon_widgetEmployeeSchedule$data = {
  readonly provider: EmployeeProvider | null;
  readonly " $fragmentType": "WidgetEmployeeScheduleIcon_widgetEmployeeSchedule";
};
export type WidgetEmployeeScheduleIcon_widgetEmployeeSchedule$key = {
  readonly " $data"?: WidgetEmployeeScheduleIcon_widgetEmployeeSchedule$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeScheduleIcon_widgetEmployeeSchedule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetEmployeeScheduleIcon_widgetEmployeeSchedule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "provider",
      "storageKey": null
    }
  ],
  "type": "WidgetEmployeeSchedule",
  "abstractKey": null
};

(node as any).hash = "79f116d3524a3506453d0224da548379";

export default node;
